import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { FaCheck, FaPencilAlt, FaTimes, FaPlus, FaTh, FaList, FaFilter } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import CardService from "../../../services/card_services"

const targets = ["player", "business"]

class AdminBuds extends Component {
    constructor(props) {
        super(props)
        this.state = {
            buds: [],
            deactivated: false,
            displaySales: false,
            selectKey: null,
            order: 'asc',
            display: "card",
            collections: [],
            dictCollections: {},
            selected: null,
            target: null,
            lvl: "all",
        }
    }

    componentDidMount = async () => {
        await this.loadCollections()
        await this.loadBuds()
    }

    loadCollections = async () => {
        const collections = await CardService.getCollections()
        let dictCollections = {}
        for (let collection of collections) {
            dictCollections[collection.collection_uuid] = collection
        }
        this.setState({ collections, dictCollections })
    }

    selectCollection = (e) => {
        this.setState({ selected: e.target.value !== "all" ? e.target.value : null })
        this.loadBuds(e.target.value !== "all" ? e.target.value : null)
    }

    loadBuds = async (collection) => {
        const data = collection ? await CardService.getCollectionBuds(collection, this.state.deactivated, this.state.target) : await CardService.getBuds(this.state.deactivated, this.state.target)
        let buds = []
        for (let bud of data) {
            if (bud.sale_info) {
                let coming = 0, current = 0, passed = 0
                for (let sale of bud.sale_info) {
                    if ((!sale.start_sale || (new Date(sale.start_sale) < new Date())) && (!sale.end_sale || (new Date(sale.end_sale) > new Date())))
                        current++
                    else if (sale.start_sale && (new Date(sale.start_sale) > new Date()))
                        coming++
                    else
                        passed++
                }
                bud.coming = coming
                bud.current = current
                bud.passed = passed
            } else {
                bud.coming = 0
                bud.current = 0
                bud.passed = 0
            }
            bud.collection = bud.collection_uuid ? this.state.dictCollections[bud.collection_uuid] : null
            buds.push(bud)
        }
        this.setState({ buds })
    }

    switchFilter = async () => {
        this.setState({ deactivated: !this.state.deactivated }, () => this.loadBuds(this.state.selected))
    }

    activate = async (bud_uuid) => {
        try {
            const data = await CardService.activateBud(bud_uuid)
            NotificationManager.success(data.message)
            this.loadBuds(this.state.selected)
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        }
    }

    deactivate = async (bud_uuid) => {
        try {
            const data = await CardService.deactivateBud(bud_uuid)
            NotificationManager.success(data.message)
            this.loadBuds(this.state.selected)
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        }
    }

    reorder = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let buds = this.state.buds
        
        // Check if sorting by date field
        const dateFields = ['last_sale', 'created_date', 'updated_date']
        if (dateFields.includes(key)) {
            if (order === 'asc')
                buds.sort((a, b) => new Date(a[key] || 0) - new Date(b[key] || 0))
            else
                buds.sort((a, b) => new Date(b[key] || 0) - new Date(a[key] || 0))
        } else {
            if (order === 'asc')
                buds.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
            else
                buds.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        }
        this.setState({ buds })
    }



    render() {
        const levels = ["starter", "common", "rare", "epic", "legendary", "mythic", "eternal"];
        const levelColors = {
            starter: "bg-gray-100 text-gray-700",
            common: "bg-green-100 text-green-700",
            rare: "bg-blue-100 text-blue-700",
            epic: "bg-purple-100 text-purple-700",
            legendary: "bg-orange-100 text-orange-700",
            mythic: "bg-red-100 text-red-700",
            eternal: "bg-gradient-to-r from-purple-500 to-pink-500 text-white"
        };
        
        return (
            <>
                <AdminLayout 
                    title="Buds Management"
                    breadcrumbs={[{ label: 'Buds' }]}
                >
                    <div className="space-y-6">
                        {/* Action Buttons */}
                        <div className="flex flex-wrap gap-3">
                            <button 
                                onClick={() => window.location.href = '/admin/buds/collection/create'}
                                className="px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                            >
                                <FaPlus />
                                Create Collection
                            </button>
                            <button 
                                onClick={() => window.location.href = '/admin/buds/create'}
                                className="px-4 py-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                            >
                                <FaPlus />
                                Create Bud
                            </button>
                        </div>

                        {/* Filters Section */}
                        <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-xl p-6 border border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                                <FaFilter className="text-gray-600" />
                                Filters & Display
                            </h3>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                {/* Collection Filter */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Collection</label>
                                    <div className="flex gap-2">
                                        <select 
                                            onChange={this.selectCollection}
                                            className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none text-sm"
                                        >
                                            <option value="all">All Collections</option>
                                            {this.state.collections.map(collection =>
                                                <option key={collection.collection_uuid} value={collection.collection_uuid}>
                                                    {collection.collection_name}
                                                </option>
                                            )}
                                        </select>
                                        {this.state.selected && (
                                            <button 
                                                onClick={() => window.location.href = `/admin/buds/collection/update/${this.state.selected}`}
                                                className="px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors"
                                                title="Edit Collection"
                                            >
                                                <FaPencilAlt />
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {/* Target Filter */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Target</label>
                                    <select 
                                        onChange={(e) => this.setState({ target: e.target.value }, () => {
                                            this.loadBuds(this.state.selected)
                                        })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none text-sm"
                                    >
                                        <option value="all">All Targets</option>
                                        {targets.map(target =>
                                            <option key={target} value={target}>{target}</option>
                                        )}
                                    </select>
                                </div>

                                {/* Level Filter */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Level</label>
                                    <select 
                                        onChange={(e) => this.setState({ lvl: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none text-sm"
                                        defaultValue="all"
                                    >
                                        <option value="all">All Levels</option>
                                        {levels.map(lvl =>
                                            <option key={lvl} value={lvl}>{lvl}</option>
                                        )}
                                    </select>
                                </div>

                                {/* View & Status Toggles */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Display Mode</label>
                                    <div className="flex gap-2">
                                        <button 
                                            onClick={() => this.setState({ display: 'table' })}
                                            className={`flex-1 px-3 py-2 rounded-lg transition-all font-medium text-sm ${
                                                this.state.display === 'table' 
                                                    ? 'bg-blue-500 text-white shadow-md' 
                                                    : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                                            }`}
                                        >
                                            <FaList className="inline mr-1" /> Table
                                        </button>
                                        <button 
                                            onClick={() => this.setState({ display: 'card' })}
                                            className={`flex-1 px-3 py-2 rounded-lg transition-all font-medium text-sm ${
                                                this.state.display === 'card' 
                                                    ? 'bg-blue-500 text-white shadow-md' 
                                                    : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
                                            }`}
                                        >
                                            <FaTh className="inline mr-1" /> Cards
                                        </button>
                                    </div>
                                    <div className="mt-2">
                                        <button 
                                            onClick={() => this.setState({ deactivated: !this.state.deactivated }, () => {
                                                this.loadBuds(this.state.selected)
                                            })}
                                            className={`w-full px-3 py-2 rounded-lg transition-all font-medium text-sm ${
                                                this.state.deactivated 
                                                    ? 'bg-gray-500 text-white shadow-md' 
                                                    : 'bg-green-500 text-white shadow-md'
                                            }`}
                                        >
                                            {this.state.deactivated ? 'Show Active' : 'Show Deactivated'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Table View */}
                        {this.state.display === "table" && (
                            <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                                <div className="overflow-x-auto">
                                    <table className="w-full">
                                        <thead className="bg-gradient-to-r from-gray-50 to-slate-100 border-b border-gray-200">
                                            <tr>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-12">#</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-32">Visual</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-200 transition-colors w-36" onClick={() => this.reorder("bud_level")}>
                                                    ⥃ Level
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-200 transition-colors" onClick={() => this.reorder("bud_name")}>
                                                    ⥃ Name
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-200 transition-colors w-28" onClick={() => this.reorder("nb_cards")}>
                                                    ⥃ Distributed
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-200 transition-colors w-28" onClick={() => this.reorder("last_sale")}>
                                                    ⥃ Last Sale
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-200 transition-colors w-24" onClick={() => this.reorder("current")}>
                                                    ⥃ On Sale
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-200 transition-colors w-32" onClick={() => this.reorder("coming")}>
                                                    ⥃ Coming
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-200 transition-colors w-28" onClick={() => this.reorder("passed")}>
                                                    ⥃ Closed
                                                </th>
                                                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-24">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                            {this.state.buds.map((bud, index) => (this.state.lvl === "all" || (this.state.lvl === bud.bud_level)) && (
                                                <tr key={`bud_${bud.bud_uuid}`} className="hover:bg-gray-50 transition-colors">
                                                    <td className="px-4 py-3">
                                                        <span className="font-semibold text-gray-700">{index + 1}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <div 
                                                            className="w-20 h-28 rounded-lg bg-cover bg-center shadow-md border border-gray-200"
                                                            style={{ backgroundImage: `url('${bud.img_url}')` }}
                                                        />
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <div className="flex flex-col gap-1">
                                                            <span className={`inline-block px-2 py-1 rounded-md text-xs font-medium ${levelColors[bud.bud_level]}`}>
                                                                {bud.bud_level}
                                                            </span>
                                                            {bud.level_max && (
                                                                <span className={`inline-block px-2 py-1 rounded-md text-xs font-medium ${levelColors[bud.level_max]}`}>
                                                                    MAX: {bud.level_max}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <div className="flex flex-col gap-1">
                                                            <span className="font-semibold text-gray-900">{bud.bud_name}</span>
                                                            <span className="text-xs text-gray-600">
                                                                <span className="font-medium">COLLECTION:</span> {bud.collection ? bud.collection.collection_name : '-'}
                                                            </span>
                                                            <span className="text-xs text-gray-600">
                                                                <span className="font-medium">TARGET:</span> {bud.target}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="font-semibold text-gray-700">{bud.nb_cards}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="text-sm text-gray-600">{bud.last_sale ? bud.last_sale : "N/A"}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="font-semibold text-green-600">{bud.current}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="font-semibold text-blue-600">{bud.coming}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="font-semibold text-gray-500">{bud.passed}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <div className="flex items-center justify-center gap-2">
                                                            <button 
                                                                onClick={() => window.location.href = `/admin/buds/details/${bud.bud_uuid}?deactivated=${this.state.deactivated}`}
                                                                className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm font-medium"
                                                            >
                                                                Details
                                                            </button>
                                                            {this.state.deactivated ? (
                                                                <button 
                                                                    onClick={() => this.activate(bud.bud_uuid)}
                                                                    className="p-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors"
                                                                    title="Activate"
                                                                >
                                                                    <FaCheck />
                                                                </button>
                                                            ) : (
                                                                <button 
                                                                    onClick={() => this.deactivate(bud.bud_uuid)}
                                                                    className="p-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors"
                                                                    title="Deactivate"
                                                                >
                                                                    <FaTimes />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Card View */}
                        {this.state.display === "card" && (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
                                {this.state.buds.map(bud => (this.state.lvl === "all" || (this.state.lvl === bud.bud_level)) && (
                                    <div key={bud.bud_uuid} className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow">
                                        {/* Card Image */}
                                        <div 
                                            className="w-full h-64 bg-cover bg-center relative"
                                            style={{ backgroundImage: `url('${bud.img_url}')` }}
                                        >
                                            <span className={`absolute top-3 left-3 px-3 py-1 rounded-lg text-xs font-bold shadow-lg ${levelColors[bud.bud_level]}`}>
                                                {bud.bud_level}
                                            </span>
                                            {bud.level_max && (
                                                <span className={`absolute top-3 right-3 px-3 py-1 rounded-lg text-xs font-bold shadow-lg ${levelColors[bud.level_max]}`}>
                                                    MAX: {bud.level_max}
                                                </span>
                                            )}
                                        </div>

                                        {/* Card Details */}
                                        <div className="p-4 space-y-2">
                                            <h3 className="font-bold text-gray-900 text-lg truncate">{bud.bud_name}</h3>
                                            
                                            <div className="space-y-1 text-sm">
                                                <div className="flex justify-between">
                                                    <span className="text-gray-600 font-medium">Target:</span>
                                                    <span className="text-gray-900">{bud.target}</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="text-gray-600 font-medium">Distributed:</span>
                                                    <span className="text-gray-900 font-semibold">{bud.nb_cards}</span>
                                                </div>
                                                <div className="flex justify-between">
                                                    <span className="text-gray-600 font-medium">Last Sale:</span>
                                                    <span className="text-gray-900">{bud.last_sale ? bud.last_sale : "N/A"}</span>
                                                </div>
                                                {bud.collection && (
                                                    <div className="flex justify-between">
                                                        <span className="text-gray-600 font-medium">Collection:</span>
                                                        <span className="text-gray-900 text-xs truncate">{bud.collection.collection_name}</span>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Sale Status */}
                                            {!this.state.deactivated && (
                                                <div className="pt-2 border-t border-gray-200">
                                                    {!bud.sale_info ? (
                                                        <p className="text-gray-500 text-sm italic">Not for sale</p>
                                                    ) : (
                                                        <p className="text-green-600 font-medium text-sm">
                                                            {bud.sale_info.length} {bud.sale_info.length > 1 ? "sales" : "sale"} 💰
                                                        </p>
                                                    )}
                                                </div>
                                            )}

                                            {/* Sale Counts */}
                                            {(bud.current > 0 || bud.coming > 0) && (
                                                <div className="flex gap-2 text-xs">
                                                    {bud.current > 0 && (
                                                        <span className="px-2 py-1 bg-green-100 text-green-700 rounded font-medium">
                                                            {bud.current} on sale
                                                        </span>
                                                    )}
                                                    {bud.coming > 0 && (
                                                        <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded font-medium">
                                                            {bud.coming} coming
                                                        </span>
                                                    )}
                                                </div>
                                            )}

                                            {/* Action Buttons */}
                                            <div className="flex gap-2 pt-3">
                                                <button 
                                                    onClick={() => window.location.href = `/admin/buds/details/${bud.bud_uuid}?deactivated=${this.state.deactivated}`}
                                                    className="flex-1 px-3 py-2 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors text-sm font-medium"
                                                >
                                                    Details
                                                </button>
                                                {!this.state.deactivated && (
                                                    <button 
                                                        onClick={() => window.location.href = `/admin/buds/update/${bud.bud_uuid}`}
                                                        className="px-3 py-2 bg-purple-100 text-purple-700 rounded-lg hover:bg-purple-200 transition-colors"
                                                        title="Edit"
                                                    >
                                                        <FaPencilAlt />
                                                    </button>
                                                )}
                                                {this.state.deactivated ? (
                                                    <button 
                                                        onClick={() => this.activate(bud.bud_uuid)}
                                                        className="px-3 py-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors"
                                                        title="Activate"
                                                    >
                                                        <FaCheck />
                                                    </button>
                                                ) : (
                                                    <button 
                                                        onClick={() => this.deactivate(bud.bud_uuid)}
                                                        className="px-3 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors"
                                                        title="Deactivate"
                                                    >
                                                        <FaTimes />
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminBuds)